class BrandPageFilmstrip {
  constructor(root) {
    this.root = root;
    this.template = root.querySelector('[data-filmstrip-template]');
    this.lanes = [...root.querySelectorAll('[data-filmstrip-lane]')];
    this.render();
  }

  shuffle(items) {
    const shuffled = items.slice();
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
    }
    return shuffled;
  }

  makeGroup(items, isDuplicate = false) {
    const group = document.createElement('div');
    group.className = 'brand-page-filmstrip__group';
    if (isDuplicate) group.setAttribute('aria-hidden', 'true');
    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.querySelectorAll('img').forEach((image) => {
        image.loading = 'eager';
        image.decoding = 'async';
        image.fetchPriority = isDuplicate ? 'low' : 'high';
        const markLoaded = () => clone.classList.add('is-loaded');
        if (image.complete && image.naturalWidth > 0) {
          markLoaded();
        } else {
          image.addEventListener('load', markLoaded, { once: true });
        }
      });
      group.append(clone);
    });
    return group;
  }

  render() {
    if (!this.template || !this.lanes.length) return;
    const sourceItems = [...this.template.content.querySelectorAll('[data-filmstrip-item]')];
    if (!sourceItems.length) return;

    const shuffled = this.shuffle(sourceItems);
    const itemsPerLane = Math.max(4, Math.min(5, Math.floor(shuffled.length / this.lanes.length)));

    this.lanes.forEach((lane, laneIndex) => {
      const start = laneIndex * itemsPerLane;
      let laneItems = shuffled.slice(start, start + itemsPerLane);
      if (laneItems.length < itemsPerLane) {
        laneItems = laneItems.concat(shuffled.slice(0, itemsPerLane - laneItems.length));
      }

      const track = document.createElement('div');
      track.className = 'brand-page-filmstrip__track';
      track.style.setProperty('--film-duration', `${26 + laneIndex * 5 + Math.floor(Math.random() * 5)}s`);
      track.append(this.makeGroup(laneItems), this.makeGroup(laneItems, true));
      lane.replaceChildren(track);
    });

    this.root.classList.add('is-ready');
  }
}

const initialiseBrandFilmstrips = (scope = document) => {
  scope.querySelectorAll('[data-brand-filmstrip]:not(.is-ready)').forEach((root) => new BrandPageFilmstrip(root));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialiseBrandFilmstrips());
} else {
  initialiseBrandFilmstrips();
}

document.addEventListener('shopify:section:load', (event) => initialiseBrandFilmstrips(event.target));
